import React from "react";
import { Globe, Lock, Tv, Users } from "lucide-react";
import DetailSheet from "../session/generate/DetailSheet";
import { Group, ItemRow, SwitchRow } from "../profile/ProfileParts";

/**
 * How to go live with a loaded session (#110). Two questions, deliberately
 * separated: "Train together" narrows who may train with you; "Broadcast"
 * says nobody does. Folding the second into the first as a fourth privacy
 * value read as a stricter Mates, which it is not. Choosing one goes live
 * straight away and closes the sheet.
 */
const GoLiveSheet = ({ open, onOpenChange, goLive, allowWatchers, setAllowWatchers }) => {
  const choose = (privacy, options) => {
    onOpenChange(false);
    goLive(privacy, options);
  };

  return (
    <DetailSheet
      open={open}
      onOpenChange={onOpenChange}
      title="Go live"
      description="Share this session in real time."
      showDescription
    >
      <div className="grid gap-5">
        <Group title="Train together" note="Everyone on one timer">
          <ItemRow
            Icon={Users}
            title="Mates"
            detail="Your mates can join"
            onClick={() => choose("friends", { allowWatchers })}
          />
          <ItemRow
            Icon={Globe}
            title="Anyone"
            detail="Anyone signed in can join"
            onClick={() => choose("public", { allowWatchers })}
          />
          <ItemRow
            Icon={Lock}
            title="Invite only"
            detail="Only people with your join code"
            onClick={() => choose("invite_only", { allowWatchers })}
          />
        </Group>

        <SwitchRow
          id="go-live-allow-watchers"
          label="Also allow watchers"
          description="Adds a watch link to a session you train together"
          checked={allowWatchers}
          onCheckedChange={setAllowWatchers}
        />

        <Group title="Broadcast">
          <ItemRow
            Icon={Tv}
            title="Watch only"
            detail="Anyone with the link, no account needed"
            onClick={() =>
              choose("invite_only", { mode: "broadcast", allowWatchers: true })
            }
          />
        </Group>
      </div>
    </DetailSheet>
  );
};

export default GoLiveSheet;
